import { render, staticRenderFns } from "./PrivacyPolicyDialog.vue?vue&type=template&id=0e5e4488&scoped=true&"
import script from "./PrivacyPolicyDialog.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyDialog.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicyDialog.vue?vue&type=style&index=0&id=0e5e4488&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5e4488",
  null
  
)

export default component.exports